import React, { memo } from 'react';
import { type NumberReadContent } from './number-read-content.ts';
import styles from './number-value-view.module.css';

/**
 * Stateless Number presentation; its alignment variable preserves V1 consumer overrides.
 */
export const NumberValueView = memo(function NumberValueView({
  content,
  showDisabledValue = false
}: {
  readonly content: NumberReadContent;
  readonly showDisabledValue?: boolean;
}) {
  return (
    <div className={styles.value} data-disabled={showDisabledValue || undefined}>
      {content.text}
    </div>
  );
});
